import Vue from 'vue';

export default {
  state: {
    states: [],
  },
  getters: {
    states(state) {
      return state.states;
    },
    // eslint-disable-next-line
    state: state => (id) => {
      return state.states.find(type => type.id === id) || {};
    },
  },
  mutations: {
    SET_STATES(state, payload) {
      state.states = payload;
    },
  },
  actions: {
    GET_STATES(context) {
      return Vue.axios.get('filters/states').then((response) => {
        context.commit('SET_STATES', response.data);
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/states.js